export default {
  sm: `
  DATA CENTER GAK 
  Chuncheon is 
  an "ark of data" 
  that stores records in 
  coexistence with nature.
  <p class="sub-text"> *Ark: an archaic word for a chest, most famously "the ark of the covenant"<br /> held two stone tablets inscribed with the Ten Commandments.</p>
  `,
  md: `
  DATA CENTER GAK Chuncheon is
  an "ark of data" 
  that stores records in coexistence with nature.
  <p class="sub-text"> *Ark: an archaic word for a chest, most famously "the ark of the covenant"<br /> held two stone tablets inscribed with the Ten Commandments.</p>
  `,
};
